const permissions = {
  SUPERADMIN: {
    routePaths: [
      'dashboard',
      'profile',
      'owner-management',
      'alerts',
      'store-management',
      'vendor-management',
      'genie-requests',
      'uploaded-files',
      'product-import',
      'import-history',
      'all-payment-methods',
      'add-payment-method',
      'all-subscriptions',
      'add-subscription',
    ],
  },
  OWNER: {
    routePaths: [
      'dashboard',
      'profile',
      'recent-products',
      'qr-scan-activity',
      'employee-management',
      'landing-page-configuration',
      'landing-preview',
      'reports',
      'print-qr',
      'qr-code-generator/settings',
      'add-qr-print',
      'qr-reprint',
      'batch-history',
      'print-history',
      'scanned-history',
      'review-qr-print',
      'quote-and-lead',
      'billing',
      'history',
      'vendors',
      'product-category',
      'product-vendor',
      'product-tag',
      'import-history',
    ],
  },
  MANAGER: {
    routePaths: [
      'dashboard',
      'profile',
      'recent-products',
      'qr-scan-activity',
      'vendors',
      'print-qr',
      'qr-code-generator/settings',
      'reports',
      'add-qr-print',
      'qr-reprint',
      'batch-history',
      'print-history',
      'review-qr-print',
      'landing-page-configuration',
      'landing-preview',
      'quote-and-lead',
      'employee-management',
      'import-history',
    ],
  },
  EMPLOYEE: {
    routePaths: [
      'dashboard',
      'profile',
      'recent-products',
      'qr-scan-activity',
      'product-lookup',
      'print-qr',
      'reports',
    ],
  },
};

export default permissions;
